type ContainerProps = React.FormHTMLAttributes<HTMLFormElement> & {
  children: React.ReactNode;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
};

export default function Container({
  children,
  onSubmit,
  ...props
}: ContainerProps) {
  return (
    <form noValidate className="space-y-4" onSubmit={onSubmit} {...props}>
      {children}
    </form>
  );
}
